import styled from "styled-components";

export const DeletePopupWrapper = styled.div`
  width: 514px;
  height: 275px;
  padding: 70px 15px 24px 15px;
  border-radius: 13px;
  background: #fff;
  z-index: 1000;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;

  > .title {
    font-family: Pretendard;
    font-size: 25px;
    font-weight: 600;
    text-align: center;
  }

  > .button-group {
    margin-top: 63px;
    display: flex;
    gap: 8px;
    justify-content: space-between;

    > .button {
      width: 135px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      border-radius: 8px;
      color: var(--Purple-300, #6436e7);
      box-sizing: border-box;
      cursor: pointer;

      &.red {
        width: 341px;
        background: #d91818;
        color: #fff;
      }
    }
  }
`;
